module.exports = __webpack_public_path__ + "media/file-icons/zip-4273e932.gif";